import type { ActivityUserInterfaceItem } from "@/types/activity";

/**
 * Calculates and updates widget heights for media players.
 *
 * @param pageItems The list of items on the current page.
 * @param mediaMinHeight The calculated minimum height for media players.
 * @returns true if any changes were made, false otherwise.
 */
export function adjustWidgetHeights(
  pageItems: ActivityUserInterfaceItem[],
  mediaMinHeight: number
): boolean {
  let doSave = false;

  for (const item of pageItems) {
    const heightDiff = mediaMinHeight - item.size.height;
    if (item.type === "media_player" && heightDiff > 0) {
      item.size.height = item.size.height + heightDiff;
      let hasCollision = false;

      for (const itm of pageItems) {
        if (item === itm) continue;

        // Check for overlap (AABB)
        if (
          item.location.x < itm.location.x + itm.size.width &&
          itm.location.x < item.location.x + item.size.width &&
          item.location.y < itm.location.y + itm.size.height &&
          itm.location.y < item.location.y + item.size.height
        ) {
          hasCollision = true;
          break;
        }
      }

      if (hasCollision) {
        for (const itm of pageItems) {
          if (item !== itm && itm.location.y >= item.location.y) {
            itm.location.y = itm.location.y + heightDiff;
          }
        }
      }

      doSave = true;
    }
  }

  return doSave;
}

/**
 * Calculates and updates widget widths for media players.
 *
 * @param pageItems The list of items on the current page.
 * @param newWidth The new width to set for media players.
 * @returns true if any changes were made, false otherwise.
 */
export function adjustWidgetWidths(
  pageItems: ActivityUserInterfaceItem[],
  newWidth: number
): boolean {
  let doSave = false;

  for (const item of pageItems) {
    const widthDiff = newWidth - item.size.width;
    if (item.type === "media_player" && widthDiff > 0) {
      item.size.width = newWidth;
      let hasCollision = false;

      for (const itm of pageItems) {
        if (item === itm) continue;

        // Check for overlap (AABB)
        if (
          item.location.x < itm.location.x + itm.size.width &&
          itm.location.x < item.location.x + item.size.width &&
          item.location.y < itm.location.y + itm.size.height &&
          itm.location.y < item.location.y + item.size.height
        ) {
          hasCollision = true;
          break;
        }
      }

      if (hasCollision) {
        for (const itm of pageItems) {
          if (item !== itm && itm.location.x >= item.location.x) {
            itm.location.x = itm.location.x + widthDiff;
          }
        }
      }

      doSave = true;
    } else if (item.type === "media_player" && widthDiff !== 0) {
      item.size.width = newWidth;
      doSave = true;
    }
  }

  return doSave;
}
